import { render } from "./Group.vue?vue&type=template&id=727cd5d4&scoped=true&lang=pug"
import script from "./Group.vue?vue&type=script&setup=true&lang=js"
export * from "./Group.vue?vue&type=script&setup=true&lang=js"

import "./Group.vue?vue&type=style&index=0&id=727cd5d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727cd5d4"]])

export default __exports__